import React, { memo, useCallback, useMemo, Component, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Popover, { PopoverAnimationVertical } from 'components/ContextPopover';
import PropTypes from 'prop-types';

import { DocumentActions } from 'actions';

import { PopOverCellAddDocument, PopOverCellAddFolder } from 'components/popovers';
import useUploadFiles from 'containers/documents/hooks/useUploadFiles';

import styles from './styles';

const propTypes = {
    folderSelected: PropTypes.object,
};

function mapStateToProps(state) {
    let permission = state.config.permission;
    let documentPermission = permission.crud_permission.DOCUMENT;
    let folderPermission = permission.crud_permission.DOCUMENTLIBRARY;
    return {
        showCreateDocument: permission.documentManagement && documentPermission.create,
        showCreateFolder: permission.documentManagement && folderPermission.create,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showCreateFolderAction: bindActionCreators(DocumentActions, dispatch).showCreateFolder,
        addMultipleDocumentsToUpload: bindActionCreators(DocumentActions, dispatch)
            .addMultipleDocumentsToUpload,
    };
}

const DocumentAddPopOver = memo(
    ({
        showCreateFolderAction,
        folderSelected,
        folder,
        onRequestClose,
        entityId,
        entityType,
        anchorEl,
        showCreateDocument,
        showCreateFolder,
        open,
        fetchData,
    }) => {
        const { onSelectFile } = useUploadFiles();

        const fileInputEl = useRef(null);
        const handleOpenDialogAddFolder = useCallback(() => {
            return () => {
                const currentFolder = folder ? folder : folderSelected.id;
                const crudAction = 'create';
                const elementType = 'folder';
                showCreateFolderAction(
                    true,
                    currentFolder,
                    entityType,
                    null,
                    crudAction,
                    elementType,
                    entityId,
                );
                onRequestClose && onRequestClose();
            };
        }, [showCreateFolderAction, folderSelected, folder, onRequestClose, entityId, entityType]);

        const openPopOver = useCallback(() => {
            if (fileInputEl.current) {
                fileInputEl.current.value = null;
                fileInputEl.current.click();
            }
        }, []);

        const handleOpenAddDocument = useCallback(() => {
            return () => {
                openPopOver();
                onRequestClose && onRequestClose();
            };
        }, [openPopOver, onRequestClose]);

        return (
            <span>
                <Popover
                    style={styles.popOver}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    onRequestClose={onRequestClose}
                    animation={PopoverAnimationVertical}
                >
                    <div style={styles.contentPopup}>
                        <PopOverCellAddDocument
                            enabled={showCreateDocument}
                            permission={showCreateDocument}
                            handleOnClick={handleOpenAddDocument}
                        />
                        <PopOverCellAddFolder
                            enabled={showCreateFolder}
                            permission={showCreateFolder}
                            handleOnClick={handleOpenDialogAddFolder}
                        />
                    </div>
                </Popover>
                <input
                    style={{ display: 'none' }}
                    type={'file'}
                    multiple={true}
                    ref={fileInputEl}
                    onChange={onSelectFile({
                        onRequestClose,
                        id: entityId,
                        entity: entityType,
                        fetchData,
                        folderSelected,
                    })}
                />
            </span>
        );
    },
);

export default connect(mapStateToProps, mapDispatchToProps)(DocumentAddPopOver);
